export class QuestConstants {
  static HSCVisualizationEntryIndicator = "entry_indicator";
  static HSCVisualizationReminderChart = "reminder_chart";
  static HSCVisualizationStackedBarGraph = "stacked_bar_graph";
  static HSCVisualizationBarGraph = "bar_graph";
  static HSCVisualizationSymptomTracker = "symptom_tracker";
  static HSCVisualizationLineGraph = "line_graph";
}
